import React, { FC, useEffect } from 'react';
import './DashboardInfo.scss';
import { formatClockDate, formatClockTime, formatRelativeTime } from 'utils/format';

interface DashboardInfoProps {
    dashboardName: string | null;
    dashboardLastUpdatedAt: Date | null;
}

const DashboardInfo: FC<DashboardInfoProps> = (props) => {
    const [currentTime, setCurrentTime] = React.useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => setCurrentTime(new Date()), 1000);

        return function cleanup() {
            clearInterval(interval);
        };
    });

    return (
        <div className="dashboard-info" data-testid="dashboard-info">
            {props.dashboardName ?? '—'}
            <div className="dashboard-info__clock">
                <span>{formatClockDate(currentTime)}</span>|<span>{formatClockTime(currentTime)}</span>
                <div>
                    {props.dashboardLastUpdatedAt ? (
                        <span>Last updated {formatRelativeTime(props.dashboardLastUpdatedAt)}</span>
                    ) : (
                        '—'
                    )}
                </div>
            </div>
        </div>
    );
};

export default DashboardInfo;
